var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role",class:{ crosswise_role: !_vm.vertical }},[_c('div',{staticClass:"role_cont"},[_c('div',{staticClass:"prod"},[_c('span',[_vm._v("商品")]),_c('span',[_vm._v(_vm._s(_vm.roleInfo.order_name))])]),_c('div',{staticClass:"desc"},[_c('span',[_vm._v("角色名")]),_c('span',[_vm._v(_vm._s(_vm.roleInfo.rolename))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }